import { useContext } from 'react';
import { useForwardedRef } from '../../hooks';
import { SlotContext } from './SlotContext';
import styles from './styles.module.css';
export function useSlot(options) {
    const { size, ref } = options || {};
    const context = useContext(SlotContext);
    const elRef = useForwardedRef(ref);
    return {
        size: size || context.size,
        sizeClass: styles[size || context.size],
        heightClass: styles.height,
        widthClass: styles.width,
        context,
        elRef,
    };
}
